// extracted by css-extract-rspack-plugin
export default {"container":"CompactContainer-module__container__LwJv_","comments":"CompactContainer-module__comments__S3ZRm"};